import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getFrodersList = (params) => {
  return axiosClient
    .get(`/api/admin/stats/gamer-frod`, {
      params,
    })
    .then((r) => r.data);
};
